import { Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface UserInfoConfig {
  showOrgs: boolean;
  showSenderIds: boolean;
  showBalance: boolean;
  showTopUpButton: boolean;
}

export interface SenderId {
  id: string;
  senderName: string;
  defaultSenderIdentity: boolean;
  packageId: number;
  messagePackageId: string;
  apiKey: string;
  company: Company;
}


export interface Organization {
  id: string;
  name: string;
  companyCertificate: string;
  email: string;
  phoneNumber: string;
  service: string;
  createdAt: string;
  members: Member[];
  senderIds: SenderId[];
}

export interface InviteUserRequest {
  email: string;
  role: string;
  status?: boolean;
}

export interface Member {
  memberId: string;
  userId: string;
  firstName: string;
  lastName: string;
  middleName: string;
  phoneNumber: string;
  email: string;
  role: string;
  joinedAt: string;
  status: boolean;
}

export interface InviteResponse {
  inviteId: string;
  email: string;
  role: string;
  alreadyAdded: boolean;
  message: string;
  invitedAt: string;
  invitedBy: string;
}

export interface Company {
  name: string;
  companyCertificate: string;
  email: string;
  phoneNumber: string;
  service: string;
  users: any[];
}

export interface UserRole {
  role: string;
  scopeType?: string;
  scopeId?: string;
}
export default interface IZikataClientProfile {
  email: string;
  emailVerified: boolean;
  phoneVerified: boolean;
  phoneNumber: string;
  enabled: boolean;
  firstName: string;
  id: string;
  status:string;
  middleName:string;
  lastName: string;
  userRoles: UserRole[];
  username: string;
  profilePicture: IIremboProfile;
}

export interface IIremboProfile {
  contentType: string;
  file: Array<string>;
}

export const USER_INFO_CONFIG = new InjectionToken<UserInfoConfig>(
  'USER_INFO_CONFIG'
);

@Injectable({
  providedIn: 'root',
})
export abstract class UserInfoConfigService {
  abstract inviteUser(
    orgId: string,
    request: InviteUserRequest
  ): Observable<any>;
  abstract updateMemberRole(
    orgId: string,
    userId: string,
    request: InviteUserRequest
  ): Observable<any>;
  abstract toggleMember(orgId: string, userId: string): Observable<void>;
  abstract deleteMember(orgId: string, userId: string): Observable<void>;
  abstract getConfig(): Observable<UserInfoConfig>;
  abstract getSenderIds(): Observable<SenderId[]>;
  abstract getOrgs(): Observable<Organization[]>;
  abstract getBalance(senderId: string): Observable<number>;
  abstract getUserAccount(): Observable<IZikataClientProfile>;
  abstract getMemberRole(orgId: string, userId: string): Observable<Member>;
  abstract getInvitedUsers(orgId: string): Observable<InviteResponse[]>;
  abstract deleteInvite(orgId: string, inviteId: string): Observable<void>;
}
